/**
 * Autoplay for <s-rail data-autoplay="5000"> slides (one full-width slide per step).
 *
 * Advances the rail's [data-rail-track] by one slide every N ms and loops back to the start.
 * Pauses while hovered, focused, off screen or in a background tab.
 * Motion rule: runs only on desktop-class devices (min-width 768px, hover) without reduced motion;
 * phones and touch devices keep manual swipe and the prev/next buttons.
 */
const MOTION_OK = '(min-width: 768px) and (hover: hover) and (prefers-reduced-motion: no-preference)';

function setup(rail) {
  if (rail.dataset.autoplayReady) return;
  rail.dataset.autoplayReady = 'true';

  const track = rail.querySelector('[data-rail-track]');
  if (!track) return;

  const delay = Math.max(2500, Number(rail.dataset.autoplay) || 5000);
  const media = window.matchMedia(MOTION_OK);
  let timer = 0;
  let hovered = false;
  let focused = false;
  let visible = false;

  const canRun = () => media.matches && !hovered && !focused && visible && !document.hidden;

  const advance = () => {
    const width = track.clientWidth;
    if (!width) return;
    const atEnd = track.scrollLeft + width >= track.scrollWidth - 4;
    track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + width, behavior: 'smooth' });
  };

  const sync = () => {
    clearInterval(timer);
    timer = 0;
    if (canRun()) timer = window.setInterval(advance, delay);
  };

  rail.addEventListener('pointerenter', () => { hovered = true; sync(); });
  rail.addEventListener('pointerleave', () => { hovered = false; sync(); });
  rail.addEventListener('focusin', () => { focused = true; sync(); });
  rail.addEventListener('focusout', (event) => {
    if (!rail.contains(event.relatedTarget)) { focused = false; sync(); }
  });
  document.addEventListener('visibilitychange', sync);
  media.addEventListener('change', sync);

  new IntersectionObserver((entries) => {
    visible = entries.some((entry) => entry.isIntersecting);
    sync();
  }, { threshold: 0.4 }).observe(rail);
}

document.querySelectorAll('s-rail[data-autoplay]').forEach(setup);
